import { Component } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { StatusHeaderComponent } from '@valk-nx/components/ui-status-header/src/lib/status-header';

@Component({
	imports: [StatusHeaderComponent, TranslatePipe],
	selector: 'sb-order-giftcard-processing',
	templateUrl: 'order-giftcard-processing.html',
})
export class OrderGiftcardProcessingComponent {}
